import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const navItems = [
  { label: '首页', to: '/' },
  { label: '全部漫画', to: '/category/all' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-foreground-950 text-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-2-line text-lg" />
            </span>
            <span className="text-lg font-semibold text-background-50">韩漫网址</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            韩漫网址为用户提供丰富的韩漫漫画资源，涵盖恋爱、奇幻、校园、悬疑等多种题材分类，支持在线阅读和漫画检索，让您轻松找到喜爱的韩漫作品。
          </p>
          <p className="mt-4 text-xs text-background-400">
            本站所有漫画均为演示内容，仅用于产品展示，不提供真实播放与下载服务。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">热门分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            {categories.slice(0, 5).map((c) => (
              <li key={c.key}>
                <Link
                  to={`/category/${c.key}`}
                  className="transition-colors hover:text-accent-400"
                >
                  {c.name}漫画
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">快捷导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="transition-colors hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/search" className="transition-colors hover:text-accent-400">
                漫画搜索
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-400">
                关于我们
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-800/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2026 韩漫网址 · 韩漫漫画在线阅读平台</p>
          <p>友情链接：樱花书阁 · 漫域星球 · 星野动漫社</p>
        </div>
      </div>
    </footer>
  );
}